import getAuthenticatedClient from './AuthClient';
import { resources } from '../resources.js';
import { getFrequencyEventMeetings, getSubjectEvent } from '../Util/TimetableUtil';

async function getEvents(accessToken: string, calendarId: string, startDateTime: Date, endDateTime: Date) {
    const client = getAuthenticatedClient(accessToken);

    const getEventsEndpoint = resources.graph.endpoint + calendarId + '/events';

    const getEventsResponse = await client
        .api(getEventsEndpoint)
        .header('Prefer', 'outlook.timezone="Eastern Standard Time"')
        .filter('start/dateTime ge ' +
            '\'' +
            startDateTime.getFullYear() +
            '-' +
            (startDateTime.getMonth() + 1) +
            '-' +
            startDateTime.getDate() +
            'T00:00:00.00000' +
            '\' ' +
            'and ' +
            'categories/any(c:c eq \'McMaster Scheduled Event\') ' +
            'and ' +
            'end/dateTime le ' +
            '\'' +
            endDateTime.getFullYear() +
            '-' +
            (endDateTime.getMonth() + 1) +
            '-' +
            endDateTime.getDate() +
            'T23:59:59.00000' +
            '\' '
        )
        //.filter('start/dateTime ge \'2021-01-01\'')
        //.filter('categories/any(c:c eq \'McMaster Scheduled Event\')')
        .top(50)
        .skip(0)
        //.select('subject,body,bodyPreview,organizer,attendees,start,end,location')
        // .select('id')
        .get();

    //console.log(getEventsResponse);
    return getEventsResponse;

}

async function getEventInstances(accessToken: string, calendarId: string, startDateTime: string, endDateTime: string, eventId: string) {
    const client = getAuthenticatedClient(accessToken);

    const getEventInstancesEndpoint = resources.graph.endpoint + calendarId + '/events/' + eventId + '/instances?startDateTime=' + startDateTime + '&endDateTime=' + endDateTime;
    try {
        const getEventsInstancesResponse = await client
            .api(getEventInstancesEndpoint)
            .get();

        return getEventsInstancesResponse;
    } catch (error) {
        console.log(error);
    }

}

async function deleteEvents(accessToken: string, calendarId: string, eventId: string) {
    const client = getAuthenticatedClient(accessToken);
    const deleteEventsEndpoint = resources.graph.endpoint + calendarId + '/events/' + eventId;

    try {
    const deleteEventResponse = await client
        .api(deleteEventsEndpoint)
        .delete();

    return deleteEventResponse;
    } catch (error) {
        console.log(error);
    }
}

async function getCalendar(accessToken: string) {
    const client = getAuthenticatedClient(accessToken);

    const getCalendarResponse = await client
        .api(resources.graph.endpoint)
        // .filter('name eq \'' + resources.graph.calendarName + '\'')
        .filter('isDefaultCalendar eq true')
        .select('id')
        .get();

    return JSON.stringify(getCalendarResponse.value[0].id);
}

async function createCalendar(accessToken: string) {
    const client = getAuthenticatedClient(accessToken);

    const calendar = {
        name: resources.graph.calendarName
    }

    const createCalendarResponse = await client
        .api(resources.graph.endpoint)
        .post(calendar);

    return createCalendarResponse;
}

function createEvent(sections: any, meeting: any) {

    var subject = getSubjectEvent(sections);

    const event = {
        subject: subject,
        body: {
            contentType: 'HTML',
            content: ""
        },
        start: {
            dateTime: meeting.startDate + 'T' + meeting.startTime,
            timeZone: 'Eastern Standard Time'
        },
        end: {
            dateTime: meeting.startDate + 'T' + meeting.endTime,
            timeZone: 'Eastern Standard Time'
        },
        recurrence: {
            pattern: {
                type: 'weekly',
                interval: 1,
                daysOfWeek: getFrequencyEventMeetings(meeting)
            },
            range: {
                type: 'endDate',
                startDate: meeting.startDate,
                endDate: meeting.endDate
            }
        },
        location: {
            displayName: meeting.facility
        },
        // attendees: [
        //     {
        //         emailAddress: {
        //             address: student.email,
        //             name: student.firstName + ' ' + student.lastName,
        //         },
        //         type: 'required'
        //     }
        // ],
        categories: ['McMaster Scheduled Event'],
    };

    return event;
}

async function postEvent(accessToken: string, event: {}, calendarId: string) {
    const client = getAuthenticatedClient(accessToken);
    const postEventEndpoint = resources.graph.endpoint + calendarId + '/events';

    const postEventResponse = await client
        .api(postEventEndpoint)
        .post(event);

    return postEventResponse;
}

export { getCalendar, createCalendar, postEvent, createEvent, getEvents, deleteEvents, getEventInstances }